import { createSelector } from 'reselect';
import { KEY, CityPassState } from './types';
import { GlobalState } from 'store/types';

const getCityPassState = (state: GlobalState) => state[KEY] as CityPassState;

const selectLoading = createSelector(getCityPassState, (cityPass) => cityPass.action.loading);

const selectError = createSelector(getCityPassState, (cityPass) => cityPass.action.error);

const selectAction = createSelector(getCityPassState, (cityPass) => cityPass.action);

const selectTickets = createSelector(getCityPassState, (cityPass) => cityPass.tickets);

const selectAPIParams = createSelector(getCityPassState, (cityPass) => {
  if (cityPass.tickets.length) {
    return {
      tickets: cityPass.tickets
    };
  }
  return undefined;
});

const selectWasAutoReserveTriggered = createSelector(getCityPassState, (cityPass) => cityPass.wasAutoReserveTriggered);

export const selectors = {
  selectTickets,
  selectAPIParams,
  selectAction,
  selectError,
  selectLoading,
  selectWasAutoReserveTriggered
};
